import { Component, inject } from '@angular/core';
import {
  ActivatedRoute,
  ActivationEnd,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { Header } from '../shared/components/header/header';
import { Sidebar } from '../shared/components/sidebar/sidebar';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '@services/loader/loader.component';
import { LocalStorage } from '@services/local-storage/local-storage';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MatButtonModule,
    CommonModule,
    MatExpansionModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    FormsModule,
    Header,
    Sidebar,
    LoaderComponent,
  ],

  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected title = 'fms';
  isHeader: any = '';
  isSidebar: any = '';
  lastRoute: any = '';
  constructor(
    public _route: Router,
    private readonly _localStorageService: LocalStorage
  ) {
    this._route.events.subscribe((event: any) => {
      this.lastRoute = event?.url ? event?.url.split('/').reverse()[0] : '';
      if (event instanceof ActivationEnd) {
        if (
          event.snapshot.data &&
          Object.keys(event.snapshot.data).length > 0
        ) {
          if (event.snapshot.data['isHeader'] >= 0) {
            this.isHeader = event.snapshot.data['isHeader'];
          }
          if (event.snapshot.data['isSidebar'] >= 0) {
            this.isSidebar = event.snapshot.data['isSidebar'];
          }
        }
      }
    });
    window.addEventListener('storage', (event) => {
      if (event.key === 'logout-event') {
        // Another tab triggered logout
        this.handleCrossTabLogout();
      }
    });
  }

  private handleCrossTabLogout() {
    this._localStorageService.clearAllData(); // ensure local cleanup
    this._route.navigate(['auth/login']);
  }

  //   private readonly router = inject(Router);
  //   private readonly route = inject(ActivatedRoute);

  //   currentRouteData = toSignal(
  //     this.router.events.pipe(
  //       // Filter for navigation end events
  //       filter((e): e is NavigationEnd => e instanceof NavigationEnd),
  //       map(() => {
  //         let route = this.route;
  //         while (route.firstChild) {
  //           route = route.firstChild;
  //         }
  //         return route.snapshot.data;
  //       })
  //     ),
  //     { initialValue: {} }
  //   );
  // }
}
